import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserProfileAccessComponent } from './user-profile-access/user-profile-access.component';
import { UserProfileGroupsComponent } from './user-profile-groups/user-profile-groups.component';
import { UserProfileAccessTimeComponent } from './user-profile-access-time/user-profile-access-time.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { UserProfileActivityComponent } from './user-profile-activity/user-profile-activity.component';
import { ResendInvitationComponent } from './resend-invitation/resend-invitation.component';
import { PendingAccountDeletionComponent } from './pending-account-deletion/pending-account-deletion.component';
import { AccountReactivatedComponent } from './account-reactivated/account-reactivated.component';
import { ProfileTooltipComponent } from './profile-tooltip/profile-tooltip.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UserProfileComponent } from './user-profile.component';
import { UserProfilePhysicalCredentialsComponent } from './user-profile-physical-credentials/user-profile-physical-credentials.component';
import { UserGroupModule } from '../user-group/user-group.module';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { AccessRightModule } from 'src/app/libs/ui/directives/access-rights/access-rights.module';
import { PhoneNumberFormatModule } from 'src/app/libs/ui/pipes/phone-number-format/phone-number-format.module';
import { UserProfileDetailsModule } from './user-profile-details/user-profile-details.module';
import { ViewUserPhysicalCredentialsComponent } from './user-profile-physical-credentials/view-user-physical-credentials/view-user-physical-credentials.component';
import { UserPhysicalCredentialsListComponent } from './user-profile-physical-credentials/user-physical-credentials-list/user-physical-credentials-list.component';
import { NoUserProfilePhysicalCredentialsComponent } from './user-profile-physical-credentials/no-user-profile-physical-credentials/no-user-profile-physical-credentials.component';
import { UserPhysicalCredentialsAccessComponent } from './user-profile-physical-credentials/user-physical-credentials-access/user-physical-credentials-access.component';
import { ParsedDateTimeModule } from 'src/app/libs/ui/pipes/parsed-date-time/parsed-date-time.module';
import { ParsedActivityDateTimeModule } from 'src/app/libs/ui/pipes/parsed-activity-date-time/parsed-activity-date-time.pipe.module';
import { SortByModule } from 'src/app/libs/ui/pipes/sort-by/sort-by.module';
import { UserProfileGroupModule } from '../user-group/user-profile-group/user-profile-group.module';
import { EventImageModule } from 'src/app/libs/ui/pipes/event-image-pipe/event-image.module';
import { StyleClassModule } from 'src/app/libs/ui/pipes/event-code-style-pipe/style-event-code.module';
import { ProfilePictureModule } from 'src/app/shared-layout/Components/profile-picture/profile-picture.module';
import { UserProfileAccessTimeUpdateComponent } from './user-profile-access-time-update/user-profile-access-time-update.component';
import { CompletedModule } from '../add-user/completed/completed.module';
import { ResendSuccessModule } from './completed/resend-success.module';
import { ParsedTimeModule } from 'src/app/libs/ui/pipes/parsed-time/parsed-time.module';
import { UpdateUserAccessComponent } from './user-profile-access/update-user-access/update-user-access.component';
import { RemoveUserAccessComponent } from './user-profile-access/remove-user-access/remove-user-access.component';
import { WithTooltipModule } from 'src/app/shared-layout/Components/with-tooltip/with-tooltip.module';
import { UserProfileGroupsWithoutSchedulerComponent } from './user-profile-groups-without-scheduler/user-profile-groups-without-scheduler.component';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
  declarations: [
    UserProfileComponent,
    ProfileTooltipComponent,
    UserProfileAccessComponent,
    UserProfileGroupsComponent,
    UserProfileAccessTimeComponent,
    UserProfilePhysicalCredentialsComponent,
    UserProfileActivityComponent,
    ResendInvitationComponent,
    PendingAccountDeletionComponent,
    AccountReactivatedComponent,
    ViewUserPhysicalCredentialsComponent,
    UserPhysicalCredentialsListComponent,
    NoUserProfilePhysicalCredentialsComponent,
    UserPhysicalCredentialsAccessComponent,
    UserProfileAccessTimeUpdateComponent,
    UpdateUserAccessComponent,
    RemoveUserAccessComponent,
    UserProfileGroupsWithoutSchedulerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ResendSuccessModule,
    SharedLayoutModule,
    WithTooltipModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatButtonToggleModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatIconModule,
    MatButtonModule,
    PhoneNumberFormatModule,
    AccessRightModule,
    UserProfileDetailsModule,
    UserGroupModule,
    ParsedDateTimeModule,
    ParsedActivityDateTimeModule,
    SortByModule,
    UserProfileGroupModule,
    EventImageModule,
    StyleClassModule,
    ProfilePictureModule,
    CompletedModule,
    ParsedTimeModule,
    TranslateModule,
  ],
  providers: [LocalizationService, TranslateModule],
  exports: [UserProfileComponent, ProfileTooltipComponent],
})
export class UserProfileModule {}
